export default "__VITE_ASSET__BnEXU$rP__"